import Decimal from "decimal.js";

export const enum FEE {
	MC_CLEARING_ACQUIRER_POS,
	MC_ACQUIRER_VOLUME_FEE,
	MC_ACQUIRING_REPORTED_TRANSACTION_FEE,
	MC_INNOVATION_FUND,
	MC_ACQUIRER_AUTHORISATION_FEE,
	MC_NON_TRX_BASED_CARD_SCHEME_FEE,
	MC_ACQUIRER_CROSS_BORDER_FEE_CONSUMER,
	MC_ACQUIRER_CROSS_BORDER_FEE_COMMERCIAL,
	MC_ACQUIRER_CARD_NOT_PRESENT_FEE,
	MC_ACQUIRER_MAIL_ORDER_TELEPHONE_ORDER_MOTO_FEE,
	MC_NON_EMV_CONTACTLESS_ACQUIRER_FEE,
	MC_EMV_3DS_AUTHENTICATION_FEE,
	MC_EMV_3DS_AUTHENTICATION_FEE_RECURRING,
	MC_EMV_3DS_CARD_ADD_FEE,
	MC_ADDRESS_VERIFICATION_SERVICE_FEE,
	MC_CVC2_FEE,
	MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_F2F,
	MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_CNP,
	MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NO_AUTHENTICATION,
	MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NOT_TOKENIZED_COF,
	MC_EXEMPTION_INDICATOR_FEE,
	MC_AUTHORISATION_INTEGRITY_FEE,
	MC_PREAUTHORISATION_FEE,
	MC_PREAUTHORISATION_FEE_FOR_AFD_AND_EVC,
	MC_PSD2_KEY_ENTERED_TRANSACTION_FEE,
	MC_PSD2_CHIP_TRANSACTIONS_WITHOUT_CVM_FEE,
	MC_REATTEMPTS_FEE,
	MC_SINGLE_TAP_ENABLEMENT_FEE,
	MC_GLOBAL_WHOLESALE_TRAVEL_TRANSACTION_PROGRAM_GWTTP_FEE,
	MC_NON_LOCAL_CURRENCY_FEE,
	MC_FREIGHT_PROGRAM_ACQUIRER_SCHEME_FEE,
	MC_FREIGHT_PROGRAM_ACQUIRER_SWITCH_FEE,

	VISA_ACQUIRER_CLEARING_AND_SETTLEMENT_FEE,
	VISA_ACQUIRER_AUTHORIZATION_FEE,
	VISA_CYBER_THREAT_PROTECTION_FEE,
	VISA_INNOVATION_AND_MARKET_DEVELOPMENT_IMD_FEE,
	VISA_NON_TRX_BASED_CARD_SCHEME_FEE,
	VISA_ACQUIRER_CARD_PRESENT_SERVICE_FEE,
	VISA_ACQUIRER_CARD_NOT_PRESENT_SERVICE_FEE,
	VISA_INTERNATIONAL_CARD_NOT_PRESENT_FEE,
	VISA_INTERNATIONAL_ACQUIRING_F2F_AND_CNP,
	VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_F2F_AND_CNP,
	VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_CNP_ONLY,
	VISA_SECURE_CREDENTIAL_CNP_FEE,
	VISA_NON_DOMESTIC_SETTLEMENT_CURRENCY_VOLUME_FEE,
	VISA_ESTIMATED_AND_INCREMENTAL_AUTHORIZATION_FEE,
	VISA_NON_EMV_TERMINAL_FEE,
	VISA_3DS_ACQUIRER_AUTHENTICATION_REQUEST_FEE,
	VISA_SECURE_FEE_CIT_WITH_DATA_QUALITY,
	VISA_SECURE_FEE_CIT_WITHOUT_DATA_QUALITY,
	VISA_SECURE_FEE_MIT_WITH_DATA_QUALITY,
	VISA_SECURE_FEE_MIT_WITHOUT_DATA_QUALITY,
	VISA_TOKEN_FACILITATION_FEE_F2F,
	VISA_TOKEN_FACILITATION_FEE_CNP,
	VISA_ADDRESS_VERIFICATION_SERVICE,
	VISA_REATTEMPTS_FEE,
	VISA_PROCESSING_INTEGRITY_FEES,
	VISA_INTEGRITY_RISK_FEE,
	VISA_COMMERCIAL_CHOICE_TRAVEL_FEE,
	VISA_CARD_VERIFICATION_VALUE_CVV2_FEE,
	VISA_REVERSAL_FEE,
}

// export type FeeKey = keyof typeof FEE;

// export const FEE_KEYS = new Map<FEE, FeeKey>(
// 	Object.entries(FEE).map(([key, value]: [any, any]) => {
// 		return [value, key] as any;
// 	})
// );

//!TODO: currency;
export interface CardFeeEntry {
	value: number;
	currency?: "USD" | "EUR";
	additionalPercent?: number;
	isPercent?: boolean;
	transactionType?: "consumer" | "commercial";
	amountMin?: number;
	amountMinInclude?: number;
	amountMax?: number;
	amountMaxInclude?: number;
	maxValue?: number;
	minDate?: number;
	maxDate?: number;
	excludeBothExtendedEurozone?: boolean;
	cardNotPresent?: boolean;
	three3ds2_or_mdes?: boolean;
	non_secure_cnp_only?: boolean;
	non_secure_ecom_or_moto_trx_with_cvc2?: boolean;
	cnp_with_mc_tokens?: boolean;
	cnp_only?: boolean;
	f2f_and_cnp?: boolean;
	cardholder_initiated_with_data_quality?: boolean;
	cnp_neither_secure_nor_tokenized?: boolean;
	cnp_with_visa_token?: boolean;
	merchants_with_mcc_5967_7273_or_crypto_purchase_transactions?: boolean;
	cvv2_verification_with_match_or_no_match_result?: boolean;
	status?: "approved" | "declined";
}

export interface CardFee {
	id: FEE;
	name: string;
	applyesEveryTrx?: boolean;
	applyRule?: string;
	domestic?: CardFeeEntry[];
	intra?: CardFeeEntry[];
	inter?: CardFeeEntry[];
}

export interface CardFeeSection {
	card_type: "mastercard" | "visa" | "visa_debit";
	entries: CardFee[];
}

export const cardFeeData: CardFeeSection[] = [
	{
		card_type: "mastercard",
		entries: [
			{
				id: FEE.MC_CLEARING_ACQUIRER_POS,
				name: "MC Clearing Acquirer POS",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0003,
						amountMax: 2.5,
					},
					{
						value: 0.0012,
						amountMinInclude: 2.5,
						amountMaxInclude: 10,
					},
					{
						value: 0.006,
						amountMin: 10,
						amountMaxInclude: 100,
					},
					{
						value: 0.012,
						amountMin: 100,
					},
				],
				intra: [
					{
						value: 0.0003,
						amountMax: 2.5,
					},
					{
						value: 0.0012,
						amountMinInclude: 2.5,
						amountMaxInclude: 10,
					},
					{
						value: 0.006,
						amountMin: 10,
						amountMaxInclude: 100,
					},
					{
						value: 0.012,
						amountMin: 100,
					},
				],
				inter: [
					{
						value: 0.006,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_VOLUME_FEE,
				name: "MC Acquirer Volume Fee",
				applyRule: "Rates revised as of 13/07/2026. An additional 0.03% rate applies to commercial products.",
				applyesEveryTrx: true,

				domestic: [
					{ value: 0.035, isPercent: true, transactionType: "consumer" },
					{ value: 0.035, isPercent: true, transactionType: "commercial", maxDate: 1783900800000 },
					{ value: 0.065, isPercent: true, transactionType: "commercial", minDate: 1783900800000 },
				],
				intra: [
					{ value: 0.035, isPercent: true, transactionType: "consumer" },
					{ value: 0.035, isPercent: true, transactionType: "commercial", maxDate: 1783900800000 },
					{ value: 0.065, isPercent: true, transactionType: "commercial", minDate: 1783900800000 },
				],
				inter: [
					{ value: 0.035, isPercent: true, transactionType: "consumer" },
					{ value: 0.035, isPercent: true, transactionType: "commercial", maxDate: 1783900800000 },
					{ value: 0.065, isPercent: true, transactionType: "commercial", minDate: 1783900800000 },
				],
			},
			{
				id: FEE.MC_ACQUIRING_REPORTED_TRANSACTION_FEE,
				name: "MC Acquiring Reported Transaction Fee",
				applyesEveryTrx: true,

				inter: [
					{
						value: 0.11,
						isPercent: false,
					},
				],
			},
			{
				id: FEE.MC_INNOVATION_FUND,
				name: "MC Innovation Fund",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.006,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.006,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.006,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_AUTHORISATION_FEE,
				name: "MC Acquirer Authorisation Fee",
				applyRule:
					"Rates are getting revised as of 05/01/2026. The revised fees will both be fixed and have a transaction amount component which categorically divides transactions into “Low Value” (<= 10 EUR) or “Standard Value” (>10 EUR) transactions",
				applyesEveryTrx: true,

				domestic: [
					{ value: 0.009, isPercent: true, maxDate: 1767571200000 },
					{ value: 0.0001, isPercent: false, minDate: 1767571200000, amountMaxInclude: 10 },
					{ value: 0.006, isPercent: false, minDate: 1767571200000, amountMin: 10 },
				],

				intra: [
					{ value: 0.009, isPercent: true },
					{ value: 0.0005, isPercent: false, minDate: 1767571200000, amountMaxInclude: 10 },
					{ value: 0.0078, isPercent: false, minDate: 1767571200000, amountMin: 10 },
				],
				inter: [
					{ value: 0.009, isPercent: true },
					{ value: 0.0015, isPercent: false, minDate: 1767571200000, amountMaxInclude: 10 },
					{ value: 0.01, isPercent: false, minDate: 1767571200000, amountMin: 10 },
				],
			},
			{
				id: FEE.MC_NON_TRX_BASED_CARD_SCHEME_FEE,
				name: "Non-Trx based Card Scheme Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0168,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.0168,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.0168,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_CROSS_BORDER_FEE_CONSUMER,
				name: "MC Acquirer Cross-Border Fee (Consumer)",
				applyRule:
					"Excluding Intra-Europe trx in EURO where merchant and issuer country both are in the extended Eurozone (Eurozone & Sweden) Intra-Europe rates revised for consumer cards as of 14/07/2025",
				intra: [
					{ value: 0.075, isPercent: true, transactionType: "consumer", maxDate: 1752451200000, excludeBothExtendedEurozone: true },
					{ value: 0.12, isPercent: true, transactionType: "consumer", minDate: 1752451200000, excludeBothExtendedEurozone: true },
				],
				inter: [{ value: 0.75, isPercent: true, transactionType: "consumer" }],
			},
			{
				id: FEE.MC_ACQUIRER_CROSS_BORDER_FEE_COMMERCIAL,
				name: "MC Acquirer Cross-Border Fee (Commercial)",
				applyRule:
					"Excluding Intra-Europe trx in EURO where merchant and issuer country both are in the extended Eurozone (Eurozone & Sweden) Intra-Europe rates revised for commercial cards as of 14/07/2025",

				intra: [
					{ value: 0.075, isPercent: true, transactionType: "commercial", maxDate: 1752451200000, excludeBothExtendedEurozone: true },
					{ value: 0.17, isPercent: true, transactionType: "commercial", minDate: 1752451200000, excludeBothExtendedEurozone: true },
				],
				inter: [{ value: 0.75, isPercent: true, transactionType: "commercial" }],
			},
			{
				id: FEE.MC_ACQUIRER_CARD_NOT_PRESENT_FEE,
				name: "MC Acquirer Card-Not-Present Fee",
				applyRule:
					"Applies for card-not-present transactions. Excluding Intra-Europe trx in EURO where merchant and issuer country both are in the extended Eurozone (Eurozone & Sweden)",

				intra: [
					{
						value: 0.025,
						isPercent: true,
						excludeBothExtendedEurozone: true,
						cardNotPresent: true,
					},
				],
				inter: [
					{
						value: 0.15,
						isPercent: true,
						cardNotPresent: true,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_MAIL_ORDER_TELEPHONE_ORDER_MOTO_FEE,
				name: "MC Acquirer Mail Order / Telephone Order (MOTO) Fee",
				applyRule: "Applies to all Card not Present MOTO trx",

				domestic: [
					{
						value: 0.025,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.025,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_NON_EMV_CONTACTLESS_ACQUIRER_FEE,
				name: "MC Non-EMV/ Contactless Acquirer Fee",
				applyRule: "Non-EMV / Non-CLP terminal only",

				domestic: [
					{
						value: 0.026,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.026,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.026,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_EMV_3DS_AUTHENTICATION_FEE,
				name: "MC EMV 3DS Authentication Fee",
				applyRule:
					"Applies for EMV 3DS (3DS2) authenticated cardholder intitiated purchase. Also applies to MDES Authenticated Transactions (all token). Rates are getting revised as of 01/07/2026.",

				domestic: [
					{ value: 0.0155, isPercent: true, maxValue: 0.155, maxDate: 1782864000000, three3ds2_or_mdes: true },
					{ value: 0.018, isPercent: true, maxValue: 1.8, minDate: 1782864000000, status: "approved", three3ds2_or_mdes: true },
					{ value: 0.018, isPercent: true, maxValue: 0.18, minDate: 1782864000000, status: "declined", three3ds2_or_mdes: true },
				],
				intra: [
					{ value: 0.0155, isPercent: true, maxValue: 0.155, maxDate: 1782864000000, three3ds2_or_mdes: true },
					{ value: 0.018, isPercent: true, maxValue: 1.8, minDate: 1782864000000, status: "approved", three3ds2_or_mdes: true },
					{ value: 0.018, isPercent: true, maxValue: 0.18, minDate: 1782864000000, status: "declined", three3ds2_or_mdes: true },
				],
				inter: [
					{ value: 0.031, isPercent: true, maxValue: 0.31, maxDate: 1782864000000, three3ds2_or_mdes: true },
					{ value: 0.036, isPercent: true, maxValue: 3.6, minDate: 1782864000000, status: "approved", three3ds2_or_mdes: true },
					{ value: 0.036, isPercent: true, maxValue: 0.36, minDate: 1782864000000, status: "declined", three3ds2_or_mdes: true },
				],
			},
			{
				id: FEE.MC_EMV_3DS_AUTHENTICATION_FEE_RECURRING,
				name: "MC EMV 3DS Authentication Fee - Recurring",
				applyRule:
					"Applies for EMV 3DS (3DS2) authenticated merchant initiated recurring payment (not applied to standard authorization only recurring transactions)",

				domestic: [
					{
						value: 0.005,
						isPercent: true,
						maxValue: 0.05,
					},
				],
				intra: [
					{
						value: 0.005,
						isPercent: true,
						maxValue: 0.05,
					},
				],
				inter: [
					{
						value: 0.01,
						isPercent: true,
						maxValue: 0.1,
					},
				],
			},
			{
				id: FEE.MC_EMV_3DS_CARD_ADD_FEE,
				name: "MC EMV 3DS Card Add Fee",
				applyRule: "Applies for EMV 3DS (3DS2) authentication for purpose of adding card for COF",

				domestic: [
					{
						value: 0.03,
					},
				],
				intra: [
					{
						value: 0.03,
					},
				],
				inter: [
					{
						value: 0.03,
					},
				],
			},
			{
				id: FEE.MC_ADDRESS_VERIFICATION_SERVICE_FEE,
				name: "MC Address Verification Service Fee",
				applyRule: "Applies for non-secure authorization requests with AVS data",

				domestic: [
					{
						value: 0.01,
					},
				],
				intra: [
					{
						value: 0.01,
					},
				],
				inter: [
					{
						value: 0.01,
					},
				],
			},
			{
				id: FEE.MC_CVC2_FEE,
				name: "MC CVC2 Fee",
				applyRule: "Applies for non-secure e-com or MOTO trx with CVC2",

				domestic: [
					{
						value: 0.0025,
						non_secure_ecom_or_moto_trx_with_cvc2: true,
					},
				],
				intra: [
					{
						value: 0.0025,
						non_secure_ecom_or_moto_trx_with_cvc2: true,
					},
				],
				inter: [
					{
						value: 0.0025,
						non_secure_ecom_or_moto_trx_with_cvc2: true,
					},
				],
			},
			{
				id: FEE.MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_F2F,
				name: "MC Token Validation and Lifecycle Service Fee (F2F)",
				applyRule: "Applies for F2F transactions that are processed with MC tokens",

				domestic: [
					{
						value: 0.01,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.01,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_CNP,
				name: "MC Token Validation and Lifecycle Service Fee (CNP)",
				applyRule: "Applies for CNP transactions that are processed with MC tokens",

				domestic: [
					{
						value: 0.02,
						isPercent: true,
						cnp_with_mc_tokens: true,
					},
				],
				intra: [
					{
						value: 0.02,
						isPercent: true,
						cnp_with_mc_tokens: true,
					},
				],
				inter: [
					{
						value: 0.1,
						isPercent: true,
						cnp_with_mc_tokens: true,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NO_AUTHENTICATION,
				name: "MC Acquirer Performance Development – No Authentication",
				applyRule: "Applies for non-Secure CNP trx only",

				domestic: [
					{
						value: 0.025,
						isPercent: true,
						non_secure_cnp_only: true,
					},
				],
				intra: [
					{
						value: 0.025,
						isPercent: true,
						non_secure_cnp_only: true,
					},
				],
				inter: [
					{
						value: 0.025,
						isPercent: true,
						non_secure_cnp_only: true,
					},
				],
			},
			{
				id: FEE.MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NOT_TOKENIZED_COF,
				name: "MC Acquirer Performance Development – Not tokenized COF",
				applyRule: "Applies for Credential on file trx without scheme token",

				domestic: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_EXEMPTION_INDICATOR_FEE,
				name: "MC Exemption Indicator Fee",
				applyRule: "Fee charged if billable exemption indicators are used (Low Fraud/TRA, Low-Value Payment, SCA Delegation)",

				domestic: [
					{
						value: 0.02,
					},
				],
				intra: [
					{
						value: 0.02,
					},
				],
				inter: [
					{
						value: 0.02,
					},
				],
			},
			{
				id: FEE.MC_AUTHORISATION_INTEGRITY_FEE,
				name: "MC Authorisation Integrity Fee",
				applyRule: "Incompliant Final Authorisations only",

				domestic: [
					{
						value: 0.28,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.28,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.28,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_PREAUTHORISATION_FEE,
				name: "MC PreAuthorisation Fee",
				applyRule: "Applies to Pre-Authorizations only, fee is applied instead of the MC Acquirer Authorisation Fee",

				domestic: [
					{
						value: 0.08,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.08,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.08,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_PREAUTHORISATION_FEE_FOR_AFD_AND_EVC,
				name: "MC PreAuthorisation Fee for AFD and EVC",
				applyRule:
					"Applied for Automatic Fuel Dispenser & Electric Vehicle Charging merchants, applies for pre-authorizations only (assessed instead of the MC Acquirer Authorization Fee)",

				domestic: [
					{
						value: 0.015,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.015,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.015,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_PSD2_KEY_ENTERED_TRANSACTION_FEE,
				name: "MC PSD2 Key Entered Transaction Fee",
				applyRule: "",

				domestic: [
					{
						value: 0.2,
					},
				],
				intra: [
					{
						value: 0.2,
					},
				],
			},
			{
				id: FEE.MC_PSD2_CHIP_TRANSACTIONS_WITHOUT_CVM_FEE,
				name: "MC PSD2 Chip transactions without CVM Fee",
				applyRule: "Domestic & Intra EEA trx at POS with chip but no CVM",

				domestic: [
					{
						value: 0.3,
					},
				],
				intra: [
					{
						value: 0.3,
					},
				],
			},
			{
				id: FEE.MC_REATTEMPTS_FEE,
				name: "MC Reattempts Fee",
				applyRule: "Applies to each reattempt authorization after an initial decline with indicator 'Do not retry' (E-com only).",

				domestic: [
					{
						value: 0.5,
					},
				],
				intra: [
					{
						value: 0.5,
					},
				],
				inter: [
					{
						value: 0.5,
					},
				],
			},
			{
				id: FEE.MC_SINGLE_TAP_ENABLEMENT_FEE,
				name: "MC Single Tap Enablement Fee",
				applyRule: "Applies for contacless transactions processed on terminals that do not support Single Tap.",

				domestic: [
					{
						value: 0.044,
						isPercent: true,
						maxValue: 0.44,
					},
				],
				intra: [
					{
						value: 0.044,
						isPercent: true,
						maxValue: 0.44,
					},
				],
				inter: [
					{
						value: 0.044,
						isPercent: true,
						maxValue: 0.44,
					},
				],
			},
			{
				id: FEE.MC_GLOBAL_WHOLESALE_TRAVEL_TRANSACTION_PROGRAM_GWTTP_FEE,
				name: "MC Global Wholesale Travel Transaction Program (GWTTP) Fee",
				applyRule:
					"Applies for GWTTP Trx only. This fee applies instead of Authorization, Clearing & Settlement and Cross-Border Fees. Rates revised as of 01/07/2025",

				domestic: [
					{
						value: 0.75,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.75,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.75,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_NON_LOCAL_CURRENCY_FEE,
				name: "MC Non-Local Currency Fee",
				applyRule: "Applies for transactions settled in a currency other than the local currency of the merchant country Introduced as of 13/10/2025",

				domestic: [
					{
						value: 0.1,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.1,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.1,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_FREIGHT_PROGRAM_ACQUIRER_SCHEME_FEE,
				name: "MC Freight Program Acquirer Scheme Fee",
				applyRule: "Applies for Freight Program Trx only. This fee applies instead of volume, reported transaction, card-not-present and MOTO fees.",

				domestic: [
					{
						value: 0.45,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.45,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.45,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.MC_FREIGHT_PROGRAM_ACQUIRER_SWITCH_FEE,
				name: "MC Freight Program Acquirer Switch Fee",
				applyRule: "Applies for Freight Program Trx only. This fee applies instead of Authorization, Preauthorization and Clearing & Settlement fees",

				domestic: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.05,
						isPercent: true,
					},
				],
			},
		],
	},

	{
		card_type: "visa",
		entries: [
			{
				id: FEE.VISA_ACQUIRER_CLEARING_AND_SETTLEMENT_FEE,
				name: "Visa Acquirer Clearing & Settlement Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.005,
					},
				],
				intra: [
					{
						value: 0.01,
					},
				],
				inter: [
					{
						value: 0.065,
					},
				],
			},
			{
				id: FEE.VISA_ACQUIRER_AUTHORIZATION_FEE,
				name: "Visa Acquirer Authorization Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0032,
					},
				],
				intra: [
					{
						value: 0.0068,
					},
				],
				inter: [
					{
						value: 0.0425,
					},
				],
			},
			{
				id: FEE.VISA_CYBER_THREAT_PROTECTION_FEE,
				name: "Visa Cyber Threat Protection Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
				intra: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
				inter: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
			},
			{
				id: FEE.VISA_INNOVATION_AND_MARKET_DEVELOPMENT_IMD_FEE,
				name: "Visa Innovation & Market Development (IMD) Fee",
				applyesEveryTrx: true,

				domestic: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
				intra: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
				inter: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
			},
			{
				id: FEE.VISA_NON_TRX_BASED_CARD_SCHEME_FEE,
				name: "Non-Trx based Card Scheme Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0046,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.0046,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.0046,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.VISA_ACQUIRER_CARD_PRESENT_SERVICE_FEE,
				name: "Visa Acquirer Card Present Service Fee",
				applyRule: "For F2F transactions only Revised rate effective 01/04/2026",
				domestic: [
					{ value: 0.025, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.033, isPercent: true, minDate: 1775001600000 },
				],
				intra: [
					{ value: 0.025, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.033, isPercent: true, minDate: 1775001600000 },
				],
				inter: [
					{ value: 0.025, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.033, isPercent: true, minDate: 1775001600000 },
				],
			},
			{
				id: FEE.VISA_ACQUIRER_CARD_NOT_PRESENT_SERVICE_FEE,
				name: "Visa Acquirer Card Not Present Service Fee",
				applyRule: "For CNP transactions only.",
				domestic: [{ value: 0.033, isPercent: true, cnp_only: true }],
				intra: [{ value: 0.033, isPercent: true, cnp_only: true }],
				inter: [{ value: 0.033, isPercent: true, cnp_only: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_CARD_NOT_PRESENT_FEE,
				name: "Visa International Card Not Present Fee",
				applyRule: "CNP trx only",
				inter: [{ value: 0.55, isPercent: true, cnp_only: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_F2F_AND_CNP,
				name: "Visa International Acquiring (F2F & CNP)",
				applyRule: "Applies to F2F and CNP transactions.",
				inter: [{ value: 0.45, isPercent: true, f2f_and_cnp: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_F2F_AND_CNP,
				name: "Visa International Acquiring (UK issued - F2F & CNP)",
				applyRule: "Applies to F2F and CNP transactions with UK-issued cards",
				intra: [{ value: 0.1, isPercent: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_CNP_ONLY,
				name: "Visa International Acquiring (UK issued - CNP only)",
				applyRule: "Applies to CNP transactions with UK-issued cards",
				intra: [{ value: 0.15, isPercent: true }],
			},
			{
				id: FEE.VISA_SECURE_CREDENTIAL_CNP_FEE,
				name: "Visa Secure Credential CNP Fee",
				applyRule: "Applies for card-not-present transactions that are neither secure nor tokenized Revised rates effective 01/10/2025",
				domestic: [
					{ value: 0.025, isPercent: true, cnp_neither_secure_nor_tokenized: true, maxDate: 1759356485000 },
					{ value: 0.075, isPercent: true, cnp_neither_secure_nor_tokenized: true, minDate: 1759356485000 },
				],
				intra: [
					{ value: 0.025, isPercent: true, cnp_neither_secure_nor_tokenized: true, maxDate: 1759356485000 },
					{ value: 0.075, isPercent: true, cnp_neither_secure_nor_tokenized: true, minDate: 1759356485000 },
				],
			},
			{
				id: FEE.VISA_NON_DOMESTIC_SETTLEMENT_CURRENCY_VOLUME_FEE,
				name: "Visa Non-Domestic Settlement Currency Volume Fee",
				applyRule:
					"Applies for transactions settled in a currency other than the local currency of the merchant country Revised rates effective from 01/04/2026, further increases announced from 01/04/2027 and 01/04/2028 as well",
				intra: [
					{ value: 0.1, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.15, isPercent: true, minDate: 1775001600000 },
				],
				inter: [
					{ value: 0.1, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.15, isPercent: true, minDate: 1775001600000 },
				],
			},
			{
				id: FEE.VISA_ESTIMATED_AND_INCREMENTAL_AUTHORIZATION_FEE,
				name: "Visa Estimated and Incremental Authorization Fee",
				applyRule: "Applies to Estimated and Incremental Authorizations only, fee is applied in addition to Visa Acquirer Authorization Fee",
				domestic: [{ value: 0.02, isPercent: true }],
				intra: [{ value: 0.02, isPercent: true }],
				inter: [{ value: 0.02, isPercent: true }],
			},
			{
				id: FEE.VISA_NON_EMV_TERMINAL_FEE,
				name: "Visa Non-EMV Terminal Fee",
				applyRule: "",
				domestic: [{ value: 0.12, currency: "USD" }],
				intra: [{ value: 0.12, currency: "USD" }],
				inter: [{ value: 0.12, currency: "USD" }],
			},
			{
				id: FEE.VISA_3DS_ACQUIRER_AUTHENTICATION_REQUEST_FEE,
				name: "Visa 3DS Acquirer Authentication Request Fee",
				applyRule: "For 3DS 1.0 and 2.0 Authentication Calls Discontinued per 01/04/2026",
				domestic: [{ value: 0.02, maxDate: 1775001600000 }],
				intra: [{ value: 0.02, maxDate: 1775001600000 }],
				inter: [{ value: 0.02, maxDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_CIT_WITH_DATA_QUALITY,
				name: "Visa Secure Fee CIT with Data Quality",
				applyRule: "Applies for cardholder initiated transactions that meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.025, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
				intra: [{ value: 0.025, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
				inter: [{ value: 0.03, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
			},
			{
				id: FEE.VISA_SECURE_FEE_CIT_WITHOUT_DATA_QUALITY,
				name: "Visa Secure Fee CIT without Data Quality",
				applyRule: "Applies for cardholder initiated transactions that do not meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.03, minDate: 1775001600000 }],
				intra: [{ value: 0.03, minDate: 1775001600000 }],
				inter: [{ value: 0.04, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_MIT_WITH_DATA_QUALITY,
				name: "Visa Secure Fee MIT with Data Quality",
				applyRule: "Applies for merchant initiated transactions that meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.002, minDate: 1775001600000 }],
				intra: [{ value: 0.002, minDate: 1775001600000 }],
				inter: [{ value: 0.002, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_MIT_WITHOUT_DATA_QUALITY,
				name: "Visa Secure Fee MIT without Data Quality",
				applyRule: "Applies for merchant initiated transactions that do not meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.003, minDate: 1775001600000 }],
				intra: [{ value: 0.003, minDate: 1775001600000 }],
				inter: [{ value: 0.003, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_TOKEN_FACILITATION_FEE_F2F,
				name: "Visa Token Facilitation Fee F2F",
				applyRule: "Applies for F2F transactions processed with a Visa token Introduced from 01/04/2026",
				domestic: [{ value: 0.01, currency: "USD", maxValue: 0.25, isPercent: true, minDate: 1775001600000 }],
				intra: [{ value: 0.01, currency: "USD", maxValue: 0.25, isPercent: true, minDate: 1775001600000 }],
				inter: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_TOKEN_FACILITATION_FEE_CNP,
				name: "Visa Token Facilitation Fee CNP",
				applyRule: "Applies for CNP transactions processed with a Visa token Introduced from 01/04/2026",
				domestic: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
				intra: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
				inter: [{ value: 0.08, currency: "USD", maxValue: 2.0, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
			},
			{
				id: FEE.VISA_ADDRESS_VERIFICATION_SERVICE,
				name: "Visa Address Verification Service",
				applyRule: "Applies for authorizations with AVS result",
				domestic: [{ value: 0.002, currency: "USD" }],
				intra: [{ value: 0.002, currency: "USD" }],
				inter: [{ value: 0.002, currency: "USD" }],
			},
			{
				id: FEE.VISA_REATTEMPTS_FEE,
				name: "Visa Reattempts Fee",
				applyRule:
					"Applies to each reattempt authorization after an initial decline with indication 'Do not retry', 'Retry with updated card data' and after >15 reattempts in 30 days",
				domestic: [{ value: 0.1, currency: "USD" }],
				intra: [{ value: 0.1, currency: "USD" }],
				inter: [{ value: 0.1, currency: "USD" }],
			},
			{
				id: FEE.VISA_PROCESSING_INTEGRITY_FEES,
				name: "Visa Processing Integrity Fees",
				applyRule: "Applies for cleared transactions that cannot be matched to authorization",
				domestic: [{ value: 0.05, currency: "USD" }],
				intra: [{ value: 0.05, currency: "USD" }],
				inter: [{ value: 0.05, currency: "USD" }],
			},
			{
				id: FEE.VISA_INTEGRITY_RISK_FEE,
				name: "Visa Integrity Risk Fee",
				applyRule: "Applies to CNP transactions for merchants with MCC 5967 & 7273 and for MCC 6012 & 6051 processing crypto purchase transactions",
				domestic: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
				intra: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
				inter: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
			},
			{
				id: FEE.VISA_COMMERCIAL_CHOICE_TRAVEL_FEE,
				name: "Visa Commercial Choice Travel Fee",
				applyRule:
					"(previously Visa Acquirer B2B Virtual Service Fee) Applies for B2B Virtual transactions only. This fee applies instead of Authorization, Clearing & Settlement and International Fees Rates revised from 01/10/2025",
				domestic: [{ value: 0.75, isPercent: true }],
				intra: [{ value: 0.75, isPercent: true }],
				inter: [{ value: 1, isPercent: true }],
			},
			{
				id: FEE.VISA_CARD_VERIFICATION_VALUE_CVV2_FEE,
				name: "Visa Card Verification Value (CVV/CVV2)",
				applyRule: "Applies to transactions with CVV2 verification, yielding a match or no-match result",
				domestic: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
				intra: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
				inter: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
			},
			{
				id: FEE.VISA_REVERSAL_FEE,
				name: "Visa Reversal Fee",
				applyRule: "Applies for Reversal Trx processed the the Visa network only",
				domestic: [{ value: 0.2712 }],
				intra: [{ value: 0.2712 }],
				inter: [{ value: 0.2712 }],
			},
		],
	},

	{
		card_type: "visa_debit",
		entries: [
			{
				id: FEE.VISA_ACQUIRER_CLEARING_AND_SETTLEMENT_FEE,
				name: "Visa Acquirer Clearing and Settlement Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.005,
					},
				],
				intra: [
					{
						value: 0.01,
					},
				],
				inter: [
					{
						value: 0.065,
					},
				],
			},
			{
				id: FEE.VISA_ACQUIRER_AUTHORIZATION_FEE,
				name: "Visa Acquirer Authorization Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0032,
					},
				],
				intra: [
					{
						value: 0.0068,
					},
				],
				inter: [
					{
						value: 0.0425,
					},
				],
			},
			{
				id: FEE.VISA_CYBER_THREAT_PROTECTION_FEE,
				name: "Visa Cyber Threat Protection Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
				intra: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
				inter: [
					{
						value: 0.0005,
						currency: "USD",
					},
				],
			},
			{
				id: FEE.VISA_INNOVATION_AND_MARKET_DEVELOPMENT_IMD_FEE,
				name: "Visa Innovation & Market Development (IMD) Fee",
				applyesEveryTrx: true,

				domestic: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
				intra: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
				inter: [
					{ value: 0.0175, isPercent: true, maxDate: 1767262926000},
					{ value: 0.02, isPercent: true, minDate: 1767262926000 },
				],
			},
			{
				id: FEE.VISA_NON_TRX_BASED_CARD_SCHEME_FEE,
				name: "Non-Trx based Card Scheme Fee",
				applyesEveryTrx: true,

				domestic: [
					{
						value: 0.0015,
						isPercent: true,
					},
				],
				intra: [
					{
						value: 0.0015,
						isPercent: true,
					},
				],
				inter: [
					{
						value: 0.0015,
						isPercent: true,
					},
				],
			},
			{
				id: FEE.VISA_ACQUIRER_CARD_PRESENT_SERVICE_FEE,
				name: "Visa Acquirer Card Present Service Fee",
				applyRule: "For F2F transactions only Revised rate effective 01/04/2026",
				domestic: [
					{ value: 0.02, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.028, isPercent: true, minDate: 1775001600000 },
				],
				intra: [
					{ value: 0.02, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.028, isPercent: true, minDate: 1775001600000 },
				],
				inter: [
					{ value: 0.02, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.028, isPercent: true, minDate: 1775001600000 },
				],
			},
			{
				id: FEE.VISA_ACQUIRER_CARD_NOT_PRESENT_SERVICE_FEE,
				name: "Visa Acquirer Card Not Present Service Fee",
				applyRule: "For CNP transactions only.",
				domestic: [{ value: 0.028, isPercent: true, cnp_only: true }],
				intra: [{ value: 0.028, isPercent: true, cnp_only: true }],
				inter: [{ value: 0.028, isPercent: true, cnp_only: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_CARD_NOT_PRESENT_FEE,
				name: "Visa International Card Not Present Fee",
				applyRule: "CNP trx only",
				inter: [{ value: 0.55, isPercent: true, cnp_only: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_F2F_AND_CNP,
				name: "Visa International Acquiring (F2F & CNP)",
				applyRule: "Applies to F2F and CNP transactions.",
				inter: [{ value: 0.45, isPercent: true, f2f_and_cnp: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_F2F_AND_CNP,
				name: "Visa International Acquiring (UK issued - F2F & CNP)",
				applyRule: "Applies to F2F and CNP transactions with UK-issued cards",
				intra: [{ value: 0.1, isPercent: true }],
			},
			{
				id: FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_CNP_ONLY,
				name: "Visa International Acquiring (UK issued - CNP only)",
				applyRule: "Applies to CNP transactions with UK-issued cards",
				intra: [{ value: 0.15, isPercent: true }],
			},
			{
				id: FEE.VISA_SECURE_CREDENTIAL_CNP_FEE,
				name: "Visa Secure Credential CNP Fee",
				applyRule: "Applies for card-not-present transactions that are neither secure nor tokenized Revised rates effective 01/10/2025",
				domestic: [
					{ value: 0.025, isPercent: true, cnp_neither_secure_nor_tokenized: true, maxDate: 1759356485000 },
					{ value: 0.075, isPercent: true, cnp_neither_secure_nor_tokenized: true, minDate: 1759356485000 },
				],
				intra: [
					{ value: 0.025, isPercent: true, cnp_neither_secure_nor_tokenized: true, maxDate: 1759356485000 },
					{ value: 0.075, isPercent: true, cnp_neither_secure_nor_tokenized: true, minDate: 1759356485000 },
				],
			},
			{
				id: FEE.VISA_NON_DOMESTIC_SETTLEMENT_CURRENCY_VOLUME_FEE,
				name: "Visa Non-Domestic Settlement Currency Volume Fee",
				applyRule:
					"Applies for transactions settled in a currency other than the local currency of the merchant country Revised rates effective from 01/04/2026, further increases announced from 01/04/2027 and 01/04/2028 as well",
				intra: [
					{ value: 0.1, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.15, isPercent: true, minDate: 1775001600000 },
				],
				inter: [
					{ value: 0.1, isPercent: true, maxDate: 1775001600000 },
					{ value: 0.15, isPercent: true, minDate: 1775001600000 },
				],
			},
			{
				id: FEE.VISA_ESTIMATED_AND_INCREMENTAL_AUTHORIZATION_FEE,
				name: "Visa Estimated and Incremental Authorization Fee",
				applyRule: "Applies to Estimated and Incremental Authorizations only, fee is applied in addition to Visa Acquirer Authorization Fee",
				domestic: [{ value: 0.02, isPercent: true }],
				intra: [{ value: 0.02, isPercent: true }],
				inter: [{ value: 0.02, isPercent: true }],
			},
			{
				id: FEE.VISA_NON_EMV_TERMINAL_FEE,
				name: "Visa Non-EMV Terminal Fee",
				applyRule: "",
				domestic: [{ value: 0.12, currency: "USD" }],
				intra: [{ value: 0.12, currency: "USD" }],
				inter: [{ value: 0.12, currency: "USD" }],
			},
			{
				id: FEE.VISA_3DS_ACQUIRER_AUTHENTICATION_REQUEST_FEE,
				name: "Visa 3DS Acquirer Authentication Request Fee",
				applyRule: "For 3DS 1.0 and 2.0 Authentication Calls Discontinued per 01/04/2026",
				domestic: [{ value: 0.02, maxDate: 1775001600000 }],
				intra: [{ value: 0.02, maxDate: 1775001600000 }],
				inter: [{ value: 0.02, maxDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_CIT_WITH_DATA_QUALITY,
				name: "Visa Secure Fee CIT with Data Quality",
				applyRule: "Applies for cardholder initiated transactions that meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.025, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
				intra: [{ value: 0.025, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
				inter: [{ value: 0.03, minDate: 1775001600000, cardholder_initiated_with_data_quality: true }],
			},
			{
				id: FEE.VISA_SECURE_FEE_CIT_WITHOUT_DATA_QUALITY,
				name: "Visa Secure Fee CIT without Data Quality",
				applyRule: "Applies for cardholder initiated transactions that do not meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.03, minDate: 1775001600000 }],
				intra: [{ value: 0.03, minDate: 1775001600000 }],
				inter: [{ value: 0.04, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_MIT_WITH_DATA_QUALITY,
				name: "Visa Secure Fee MIT with Data Quality",
				applyRule: "Applies for merchant initiated transactions that meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.002, minDate: 1775001600000 }],
				intra: [{ value: 0.002, minDate: 1775001600000 }],
				inter: [{ value: 0.002, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_SECURE_FEE_MIT_WITHOUT_DATA_QUALITY,
				name: "Visa Secure Fee MIT without Data Quality",
				applyRule: "Applies for merchant initiated transactions that do not meet the data quality mandate. Introduced from 01/04/2026",
				domestic: [{ value: 0.003, minDate: 1775001600000 }],
				intra: [{ value: 0.003, minDate: 1775001600000 }],
				inter: [{ value: 0.003, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_TOKEN_FACILITATION_FEE_F2F,
				name: "Visa Token Facilitation Fee F2F",
				applyRule: "Applies for F2F transactions processed with a Visa token Introduced from 01/04/2026",
				domestic: [{ value: 0.01, currency: "USD", maxValue: 0.25, isPercent: true, minDate: 1775001600000 }],
				intra: [{ value: 0.01, currency: "USD", maxValue: 0.25, isPercent: true, minDate: 1775001600000 }],
				inter: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000 }],
			},
			{
				id: FEE.VISA_TOKEN_FACILITATION_FEE_CNP,
				name: "Visa Token Facilitation Fee CNP",
				applyRule: "Applies for CNP transactions processed with a Visa token Introduced from 01/04/2026",
				domestic: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
				intra: [{ value: 0.05, currency: "USD", maxValue: 1.25, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
				inter: [{ value: 0.08, currency: "USD", maxValue: 2.0, isPercent: true, minDate: 1775001600000, cnp_with_visa_token: true }],
			},
			{
				id: FEE.VISA_ADDRESS_VERIFICATION_SERVICE,
				name: "Visa Address Verification Service",
				applyRule: "Applies for authorizations with AVS result",
				domestic: [{ value: 0.002, currency: "USD" }],
				intra: [{ value: 0.002, currency: "USD" }],
				inter: [{ value: 0.002, currency: "USD" }],
			},
			{
				id: FEE.VISA_REATTEMPTS_FEE,
				name: "Visa Reattempts Fee",
				applyRule:
					"Applies to each reattempt authorization after an initial decline with indication 'Do not retry', 'Retry with updated card data' and after >15 reattempts in 30 days",
				domestic: [{ value: 0.1, currency: "USD" }],
				intra: [{ value: 0.1, currency: "USD" }],
				inter: [{ value: 0.1, currency: "USD" }],
			},
			{
				id: FEE.VISA_PROCESSING_INTEGRITY_FEES,
				name: "Visa Processing Integrity Fees",
				applyRule: "Applies for cleared transactions that cannot be matched to authorization",
				domestic: [{ value: 0.05, currency: "USD" }],
				intra: [{ value: 0.05, currency: "USD" }],
				inter: [{ value: 0.05, currency: "USD" }],
			},
			{
				id: FEE.VISA_INTEGRITY_RISK_FEE,
				name: "Visa Integrity Risk Fee",
				applyRule: "Applies to CNP transactions for merchants with MCC 5967 & 7273 and for MCC 6012 & 6051 processing crypto purchase transactions",
				domestic: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
				intra: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
				inter: [{ value: 0.02, currency: "USD", additionalPercent: 0.1, merchants_with_mcc_5967_7273_or_crypto_purchase_transactions: true }],
			},
			{
				id: FEE.VISA_COMMERCIAL_CHOICE_TRAVEL_FEE,
				name: "Visa Commercial Choice Travel Fee",
				applyRule:
					"(previously Visa Acquirer B2B Virtual Service Fee) Applies for B2B Virtual transactions only. This fee applies instead of Authorization, Clearing & Settlement and International Fees Rates revised from 01/10/2025",
				domestic: [{ value: 0.75, isPercent: true }],
				intra: [{ value: 0.75, isPercent: true }],
				inter: [{ value: 1, isPercent: true }],
			},
			{
				id: FEE.VISA_CARD_VERIFICATION_VALUE_CVV2_FEE,
				name: "Visa Card Verification Value (CVV/CVV2)",
				applyRule: "Applies to transactions with CVV2 verification, yielding a match or no-match result",
				domestic: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
				intra: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
				inter: [{ value: 0.0025, cvv2_verification_with_match_or_no_match_result: true, currency: "USD" }],
			},
			{
				id: FEE.VISA_REVERSAL_FEE,
				name: "Visa Reversal Fee",
				applyRule: "Applies for Reversal Trx processed the the Visa network only",
				domestic: [{ value: 0.2712 }],
				intra: [{ value: 0.2712 }],
				inter: [{ value: 0.2712 }],
			},
		],
	},
];

const cardTypes = cardFeeData.map(i => i.card_type);
export type FeeCardType = (typeof cardTypes)[number];

const mastercardFeesList: FEE[] = [
	// FEE.MC_CLEARING_ACQUIRER_POS,
	FEE.MC_ACQUIRER_VOLUME_FEE,
	FEE.MC_ACQUIRING_REPORTED_TRANSACTION_FEE,
	FEE.MC_INNOVATION_FUND,
	FEE.MC_ACQUIRER_AUTHORISATION_FEE,
	FEE.MC_NON_TRX_BASED_CARD_SCHEME_FEE,
	FEE.MC_ACQUIRER_CROSS_BORDER_FEE_CONSUMER,
	FEE.MC_ACQUIRER_CROSS_BORDER_FEE_COMMERCIAL,
	FEE.MC_ACQUIRER_CARD_NOT_PRESENT_FEE,
	// FEE.MC_ACQUIRER_MAIL_ORDER_TELEPHONE_ORDER_MOTO_FEE,
	// FEE.MC_NON_EMV_CONTACTLESS_ACQUIRER_FEE,
	FEE.MC_EMV_3DS_AUTHENTICATION_FEE,
	// FEE.MC_EMV_3DS_AUTHENTICATION_FEE_RECURRING,
	// FEE.MC_EMV_3DS_CARD_ADD_FEE,
	// FEE.MC_ADDRESS_VERIFICATION_SERVICE_FEE,
	FEE.MC_CVC2_FEE,

	// FEE.MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_F2F,
	FEE.MC_TOKEN_VALIDATION_AND_LIFECYCLE_SERVICE_FEE_CNP,
	FEE.MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NO_AUTHENTICATION,
	// FEE.MC_ACQUIRER_PERFORMANCE_DEVELOPMENT_NOT_TOKENIZED_COF,
	// FEE.MC_EXEMPTION_INDICATOR_FEE,
	// FEE.MC_AUTHORISATION_INTEGRITY_FEE,
	// FEE.MC_PREAUTHORISATION_FEE,
	// FEE.MC_PREAUTHORISATION_FEE_FOR_AFD_AND_EVC,
	// FEE.MC_PSD2_KEY_ENTERED_TRANSACTION_FEE,
	// FEE.MC_PSD2_CHIP_TRANSACTIONS_WITHOUT_CVM_FEE,
	// FEE.MC_REATTEMPTS_FEE,
	// FEE.MC_SINGLE_TAP_ENABLEMENT_FEE,
	// FEE.MC_GLOBAL_WHOLESALE_TRAVEL_TRANSACTION_PROGRAM_GWTTP_FEE,
	// FEE.MC_NON_LOCAL_CURRENCY_FEE,
	// FEE.MC_FREIGHT_PROGRAM_ACQUIRER_SCHEME_FEE,
	// FEE.MC_FREIGHT_PROGRAM_ACQUIRER_SWITCH_FEE,
];

const visaFeesList: FEE[] = [
	FEE.VISA_ACQUIRER_CLEARING_AND_SETTLEMENT_FEE,
	FEE.VISA_ACQUIRER_AUTHORIZATION_FEE,
	FEE.VISA_CYBER_THREAT_PROTECTION_FEE,
	FEE.VISA_INNOVATION_AND_MARKET_DEVELOPMENT_IMD_FEE,
	FEE.VISA_NON_TRX_BASED_CARD_SCHEME_FEE,
	// FEE.VISA_ACQUIRER_CARD_PRESENT_SERVICE_FEE,
	FEE.VISA_ACQUIRER_CARD_NOT_PRESENT_SERVICE_FEE,
	FEE.VISA_INTERNATIONAL_CARD_NOT_PRESENT_FEE,
	FEE.VISA_INTERNATIONAL_ACQUIRING_F2F_AND_CNP,
	// FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_F2F_AND_CNP,
	// FEE.VISA_INTERNATIONAL_ACQUIRING_UK_ISSUED_CNP_ONLY,
	FEE.VISA_SECURE_CREDENTIAL_CNP_FEE,
	// FEE.VISA_NON_DOMESTIC_SETTLEMENT_CURRENCY_VOLUME_FEE,
	// FEE.VISA_ESTIMATED_AND_INCREMENTAL_AUTHORIZATION_FEE,
	// FEE.VISA_NON_EMV_TERMINAL_FEE,
	// FEE.VISA_3DS_ACQUIRER_AUTHENTICATION_REQUEST_FEE,
	FEE.VISA_SECURE_FEE_CIT_WITH_DATA_QUALITY,
	// FEE.VISA_SECURE_FEE_CIT_WITHOUT_DATA_QUALITY,
	// FEE.VISA_SECURE_FEE_MIT_WITH_DATA_QUALITY,
	// FEE.VISA_SECURE_FEE_MIT_WITHOUT_DATA_QUALITY,
	// FEE.VISA_TOKEN_FACILITATION_FEE_F2F,
	FEE.VISA_TOKEN_FACILITATION_FEE_CNP,
	// FEE.VISA_ADDRESS_VERIFICATION_SERVICE,
	// FEE.VISA_REATTEMPTS_FEE,
	// FEE.VISA_PROCESSING_INTEGRITY_FEES,
	FEE.VISA_INTEGRITY_RISK_FEE,
	// FEE.VISA_COMMERCIAL_CHOICE_TRAVEL_FEE,
	FEE.VISA_CARD_VERIFICATION_VALUE_CVV2_FEE,
	FEE.VISA_REVERSAL_FEE,
];

export const getFees = (
	convertCurrency: (amount: Decimal, fromCurrency: string, toCurrency?: string) => Decimal,
	card: { cardType: FeeCardType; cardRegion: string },
	merchant: { country: string; mcc: string },
	amount: number,
	time: number,
	transactionType: "consumer" | "commercial",
	cardNotPresent: boolean,
	status: "approved" | "declined",
	three3ds2: boolean,
	mdesAuthenticatedTransactions: boolean,
	nonSecureEcomOrMotoTrxWithCvc2: boolean,
	cnpWithMcTokens: boolean,
	nonSecureCnpOnly: boolean,
	cnpOnly: boolean,
	f2fAndCnp: boolean,
	cnpNeitherSecureNorTokenized: boolean,
	cardholderInitiatedWithDataQuality: boolean,
	cnpWithVisaToken: boolean,
	cryptoPurchaseTransaction: boolean,
	cvv2VerificationWithMatchOrNoMatchResult: boolean,
): (
	| {
			fee: number;
			name: string;
			description?: string;
			rule?: CardFeeEntry;
	  }
	| undefined
)[] => {
	let initialKeys: FEE[] = [];
	const res: (
		| {
				fee: number;
				name: string;
				description?: string;
				rule?: CardFeeEntry;
		  }
		| undefined
	)[] = [];

	if (card.cardType === "mastercard") {
		initialKeys = mastercardFeesList;
	} else if (card.cardType === "visa" || card.cardType === "visa_debit") {
		initialKeys = visaFeesList;
	}

	const system = cardFeeData.find(i => i.card_type === card.cardType);
	const region: "domestic" | "intra" | "inter" | "error" = getPaymentRegion(card, merchant);
	if (region === "error") {
		//!TODO handle error case;
	} else if (system) {
		for (let index = 0; index < initialKeys.length; index++) {
			const key = initialKeys[index];

			const feeEntry = system?.entries.find(f => f.id === key);
			if (feeEntry) {
				const feeRes = calculate({
					convertCurrency: convertCurrency,
					feeRule: feeEntry,
					region: region,
					amount: amount,
					timestamp: time,
					transactionType: transactionType,
					merchantCountry: merchant.country,
					merchantMcc: merchant.mcc,
					cardCountry: card.cardRegion,
					cardNotPresent: cardNotPresent,
					status: status,
					three3ds2: three3ds2,
					mdesAuthenticatedTransactions: mdesAuthenticatedTransactions,
					nonSecureEcomOrMotoTrxWithCvc2: nonSecureEcomOrMotoTrxWithCvc2,
					cnpWithMcTokens: cnpWithMcTokens,
					nonSecureCnpOnly: nonSecureCnpOnly,
					cnpOnly: cnpOnly,
					f2fAndCnp: f2fAndCnp,
					cnpNeitherSecureNorTokenized: cnpNeitherSecureNorTokenized,
					cardholderInitiatedWithDataQuality: cardholderInitiatedWithDataQuality,
					cnpWithVisaToken: cnpWithVisaToken,
					cryptoPurchaseTransaction: cryptoPurchaseTransaction,
					cvv2VerificationWithMatchOrNoMatchResult: cvv2VerificationWithMatchOrNoMatchResult,
				});
				res.push(feeRes);
			} else {
				res.push(undefined);
			}
		}
		return res;
	}
	return [];
};

const eeaCountries = [
	"AT",
	"BE",
	"BG",
	"HR",
	"CY",
	"CZ",
	"DK",
	"EE",
	"FI",
	"FR",
	"DE",
	"GR",
	"HU",
	"IS",
	"IE",
	"IT",
	"LV",
	"LI",
	"LT",
	"LU",
	"MT",
	"NL",
	"NO",
	"PL",
	"PT",
	"RO",
	"SK",
	"SI",
	"ES",
	"SE",
];

const europeCountries = [
	"AL",
	"AD",
	"AM",
	"AT",
	"AZ",
	"BY",
	"BE",
	"BA",
	"BG",
	"HR",
	"CY",
	"CZ",
	"DK",
	"EE",
	"FI",
	"FR",
	"GE",
	"DE",
	"GR",
	"HU",
	"IS",
	"IE",
	"IT",
	"KZ",
	"XK",
	"LV",
	"LI",
	"LT",
	"LU",
	"MT",
	"MD",
	"MC",
	"ME",
	"NL",
	"MK",
	"NO",
	"PL",
	"PT",
	"RO",
	"RU",
	"SM",
	"RS",
	"SK",
	"SI",
	"ES",
	"SE",
	"CH",
	"TR",
	"UA",
	"GB",
	"VA",
];

const getPaymentRegion = (
	card: { cardType: FeeCardType; cardRegion: string },
	merchant: { country: string; mcc: string },
): "domestic" | "intra" | "inter" | "error" => {
	// Domestic transaction: A domestic payment transaction means a card-based payment transaction
	// where the card-based payment instrument is issued by an issuing payment service provider
	// located in the same country as the that of the point of sale.
	const isDomestic = card.cardRegion.toLowerCase() === merchant.country.toLowerCase();
	if (isDomestic) return "domestic";

	//!TODO: Verify EEA country codes list
	// An Intra EEA payment transaction means a card-based payment transaction
	// where the card-based payment instrument is issued by an issuing payment service provider
	// located in a different EEA member state than that of the point of sale
	const isIntraEEA = (() => {
		return eeaCountries.includes(card.cardRegion.toUpperCase()) && eeaCountries.includes(merchant.country.toUpperCase());
	})();

	if (isIntraEEA) return "intra";

	const isInEurope = (() => {
		return europeCountries.includes(card.cardRegion.toUpperCase()) && europeCountries.includes(merchant.country.toUpperCase());
	})();

	if (isInEurope) {
		// An Intra non-EEA payment transaction means a card-based payment transaction
		// where the card-based payment instrument is issued by an issuing payment service provider
		// located outside the EEA but still in the Europe region and the point of sale is within the EEA and vice versa
		const isIntraNonEEA = (() => {
			return (
				(eeaCountries.includes(card.cardRegion.toUpperCase()) && !eeaCountries.includes(merchant.country.toUpperCase())) ||
				(!eeaCountries.includes(card.cardRegion.toUpperCase()) && eeaCountries.includes(merchant.country.toUpperCase()))
			);
		})();

		if (isIntraNonEEA) {
			return "intra";
		}
	}

	// !TODO: Verify Europe country codes list
	// An Interregional payment transaction means a card-based payment transaction
	// where the card-based payment instrument is issued by an issuing payment service provider
	// located outside of the Europe Region and the point of sale lies within the Europe Region and vice versa
	if (
		(europeCountries.includes(card.cardRegion.toUpperCase()) && !europeCountries.includes(merchant.country.toUpperCase())) ||
		(!europeCountries.includes(card.cardRegion.toUpperCase()) && europeCountries.includes(merchant.country.toUpperCase()))
	) {
		return "inter";
	}

	return "error";
};

const isBothInExtendedEurozone = (req: {
	feeRule: CardFee;
	region: "domestic" | "intra" | "inter";
	amount: number;
	currency?: string;
	transactionType: "consumer" | "commercial";
	timestamp?: number;
	merchantCountry: string;
	cardCountry: string;
}) => {
	//!TODO: Verify extended eurozone country codes list;
	const extendedEurozoneCountries = ["BG", "HR", "CY", "CZ", "EE", "HU", "LV", "LT", "PL", "RO"];
	return extendedEurozoneCountries.includes(req.cardCountry.toUpperCase()) && extendedEurozoneCountries.includes(req.merchantCountry.toUpperCase());
};

export const calculate = (req: {
	convertCurrency: (amount: Decimal, fromCurrency: string, toCurrency?: string) => Decimal;
	feeRule: CardFee;
	region: "domestic" | "intra" | "inter";
	amount: number;
	currency?: string;
	transactionType: "consumer" | "commercial";
	timestamp?: number;
	merchantCountry: string;
	merchantMcc: string;
	cardCountry: string;
	cardNotPresent: boolean;
	status: "approved" | "declined";
	three3ds2: boolean;
	mdesAuthenticatedTransactions: boolean;
	nonSecureEcomOrMotoTrxWithCvc2: boolean;
	cnpWithMcTokens: boolean;
	nonSecureCnpOnly: boolean;
	cnpOnly: boolean;
	f2fAndCnp: boolean;
	cnpNeitherSecureNorTokenized: boolean;
	cardholderInitiatedWithDataQuality: boolean;
	cnpWithVisaToken: boolean;
	cryptoPurchaseTransaction: boolean;
	cvv2VerificationWithMatchOrNoMatchResult: boolean;
}):
	| {
			fee: number;
			name: string;
			description?: string;
			rule?: CardFeeEntry;
	  }
	| undefined => {
	if (req.feeRule[req.region]) {
		const feeEntries = req.feeRule[req.region];

		if (feeEntries && feeEntries.length > 0) {
			for (let index = 0; index < feeEntries.length; index++) {
				const fee = feeEntries[index];
				if (fee.amountMax !== undefined && req.amount >= fee.amountMax) {
					continue;
				}
				if (fee.amountMaxInclude !== undefined && req.amount > fee.amountMaxInclude) {
					continue;
				}
				if (fee.amountMin !== undefined && req.amount <= fee.amountMin) {
					continue;
				}
				if (fee.amountMinInclude !== undefined && req.amount < fee.amountMinInclude) {
					continue;
				}

				if (fee.transactionType !== undefined && req.transactionType !== fee.transactionType) {
					continue;
				}

				if (fee.status !== undefined && req.status !== fee.status) {
					continue;
				}

				if (fee.minDate !== undefined || fee.maxDate !== undefined) {
					const currentTime = req.timestamp ?? new Date().getTime();
					if (fee.minDate !== undefined && currentTime < fee.minDate) {
						continue;
					}
					if (fee.maxDate !== undefined && currentTime >= fee.maxDate) {
						continue;
					}
				}
				if (fee.excludeBothExtendedEurozone !== undefined && fee.excludeBothExtendedEurozone) {
					if (isBothInExtendedEurozone(req)) {
						continue;
					}
				}
				if (fee.cardNotPresent !== undefined && fee.cardNotPresent) {
					if (!req.cardNotPresent) {
						continue;
					}
				}
				if (fee.cnp_with_mc_tokens !== undefined && fee.cnp_with_mc_tokens) {
					if (!req.cnpWithMcTokens) {
						continue;
					}
				}
				if (fee.three3ds2_or_mdes !== undefined && fee.three3ds2_or_mdes) {
					if (!req.three3ds2 && !req.mdesAuthenticatedTransactions) {
						continue;
					}
				}
				if (fee.non_secure_ecom_or_moto_trx_with_cvc2 !== undefined && fee.non_secure_ecom_or_moto_trx_with_cvc2) {
					if (!req.nonSecureEcomOrMotoTrxWithCvc2) {
						continue;
					}
				}
				if (fee.non_secure_cnp_only !== undefined && fee.non_secure_cnp_only) {
					if (!req.nonSecureCnpOnly) {
						continue;
					}
				}
				if (fee.cnp_only !== undefined && fee.cnp_only) {
					if (!req.cnpOnly) {
						continue;
					}
				}
				if (fee.f2f_and_cnp !== undefined && fee.f2f_and_cnp) {
					if (!req.f2fAndCnp) {
						continue;
					}
				}
				if (fee.cnp_neither_secure_nor_tokenized !== undefined && fee.cnp_neither_secure_nor_tokenized) {
					if (!req.cnpNeitherSecureNorTokenized) {
						continue;
					}
				}
				if (fee.cardholder_initiated_with_data_quality !== undefined && fee.cardholder_initiated_with_data_quality) {
					if (!req.cardholderInitiatedWithDataQuality) {
						continue;
					}
				}
				if (fee.cnp_with_visa_token !== undefined && fee.cnp_with_visa_token) {
					if (!req.cnpWithVisaToken) {
						continue;
					}
				}
				if (fee.cvv2_verification_with_match_or_no_match_result !== undefined && fee.cvv2_verification_with_match_or_no_match_result) {
					if (!req.cvv2VerificationWithMatchOrNoMatchResult) {
						continue;
					}
				}
				if (
					fee.merchants_with_mcc_5967_7273_or_crypto_purchase_transactions !== undefined &&
					fee.merchants_with_mcc_5967_7273_or_crypto_purchase_transactions
				) {
					const isRuleApplicableForMcc =
						req.merchantMcc === "5967" ||
						req.merchantMcc === "7273" ||
						((req.merchantMcc === "6012" || req.merchantMcc === "6051") && req.cryptoPurchaseTransaction);

					if (!isRuleApplicableForMcc) {
						continue;
					}
				}
				const initialAmount = new Decimal(req.amount);
				let feeAmount: Decimal = new Decimal(0);
				if (fee.isPercent) {
					//feeAmount = (req.amount * fee.value) / 100;
					feeAmount = initialAmount.mul(fee.value).dividedBy(100);
				} else {
					//feeAmount = fee.value;
					feeAmount = new Decimal(fee.value);
					if (fee.currency !== undefined && fee.currency !== req.currency) {
						feeAmount = req.convertCurrency(feeAmount, fee.currency, req.currency);
					}
					if (fee.additionalPercent) {
						//feeAmount += (req.amount * fee.additionalPercent) / 100;
						feeAmount = feeAmount.plus(initialAmount.mul(fee.additionalPercent).dividedBy(100));
					}
				}

				if (fee.maxValue !== undefined) {
					let feeMaxValue = new Decimal(fee.maxValue);
					if (fee.currency !== undefined && fee.currency !== req.currency) {
						feeMaxValue = req.convertCurrency(feeMaxValue, fee.currency, req.currency);
					}
					if (feeAmount.comparedTo(feeMaxValue) === 1) {
						feeAmount = new Decimal(feeMaxValue);
					}
				}

				return {
					fee: feeAmount.toNumber(),
					name: req.feeRule.name,
					description: req.feeRule.applyRule,
					rule: fee,
				};
			}
		}
	}

	return {
		fee: 0,
		name: req.feeRule.name,
		description: req.feeRule.applyRule,
	};
};

// export const calculate = (req: {
// 	cardType: FeeCardType;
// 	region: "domestic" | "intra" | "inter";
// 	amount: number;
// 	currency?: string;
// 	feeType: FEE;
// 	timestamp?: number;
// }):
// 	| {
// 			fee: number;
// 			description?: string;
// 			rule: CardFeeEntry;
// 	  }
// 	| undefined => {
// 	const system = cardFeeData.find(i => i.card_type === req.cardType);

// 	if (system) {
// 		const feeRule = system.entries.find(e => e.id === req.feeType);

// 		if (feeRule && feeRule[req.region]) {
// 			const feeEntries = feeRule[req.region];

// 			if (feeEntries && feeEntries.length > 0) {
// 				for (let index = 0; index < feeEntries.length; index++) {
// 					const fee = feeEntries[index];
// 					if (fee.amountMax !== undefined && req.amount >= fee.amountMax) {
// 						continue;
// 					}
// 					if (fee.amountMaxInclude !== undefined && req.amount > fee.amountMaxInclude) {
// 						continue;
// 					}

// 					if (fee.amountMin !== undefined && req.amount <= fee.amountMin) {
// 						continue;
// 					}

// 					if (fee.amountMinInclude !== undefined && req.amount < fee.amountMinInclude) {
// 						continue;
// 					}

// 					if (fee.minDate !== undefined || fee.maxDate !== undefined) {
// 						const currentTime = req.timestamp ?? new Date().getTime();
// 						if (fee.minDate !== undefined && currentTime < fee.minDate) {
// 							continue;
// 						}
// 						if (fee.maxDate !== undefined && currentTime >= fee.maxDate) {
// 							continue;
// 						}
// 					}

// 					const initialAmount = new Decimal(req.amount);
// 					let feeAmount: Decimal = new Decimal(0);
// 					if (fee.isPercent) {
// 						//feeAmount = (req.amount * fee.value) / 100;
// 						feeAmount = initialAmount.mul(fee.value).dividedBy(100);
// 					} else {
// 						//feeAmount = fee.value;
// 						feeAmount = new Decimal(fee.value);
// 						if (fee.additionalPercent) {
// 							//feeAmount += (req.amount * fee.additionalPercent) / 100;
// 							feeAmount = feeAmount.plus(initialAmount.mul(fee.additionalPercent).dividedBy(100));
// 						}
// 					}

// 					if (fee.maxValue !== undefined && feeAmount.comparedTo(fee.maxValue) === 1) {
// 						feeAmount = new Decimal(fee.maxValue);
// 					}

// 					return {
// 						fee: feeAmount.toNumber(),
// 						description: feeRule.applyRule,
// 						rule: fee,
// 					};
// 				}
// 			}
// 		}
// 	}
// 	return undefined;
// };
